// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1Gafp","list":"BalanceDue_list__sBMRD","listRow":"BalanceDue_listRow__TNESu","total":"BalanceDue_total__13p6O"};